/** More gallery thumbnails than this read as noise even in a wide preview. */
export const MAX_THUMBNAIL_SLOTS = 6;
